// extracted by mini-css-extract-plugin
export default {"form_wrappre":"ForgetPasswordForm_form_wrappre__sPWpT","input_wraper":"ForgetPasswordForm_input_wraper__l3CW4","loading_progress":"ForgetPasswordForm_loading_progress__7evW5"};